module.exports = __webpack_public_path__ + "static/img/58-3.b90de20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/58-3.jpg
// module id = Zi24
// module chunks = 0